// A client invoice on /finance (`modal=job-invoice&invoice=<id>`, finance-real, the user 2026-10-23), the one drawer that
// opens it on every tab: the Invoices tab's rows, and their status dropdown's Paid (`confirm=paid`, the payment step at
// once), and the client drawer's, which hands over to it on Clients, so closing it lands back there. The job form stacks
// over a draft (`stack=line-job-form`), and a job on it opens the page's job drawer in its place, on the tab the user is on
// (DD-045), so closing that leaves them where they were.
import { ENTITY_CONFIG } from "@/core/entityConfig";
import { FinanceDrawer } from "../components/FinanceDrawer";
import { JobInvoiceDrawer, toBill } from "../clientPage/JobInvoiceDrawers";
import type { LineJob } from "../types";
import { useAgencyJobInvoiceDrawer } from "./hooks/useAgencyJobInvoiceDrawer";

const INVOICE = ENTITY_CONFIG.invoice;

interface Props {
  invoiceId: string;
  paying: boolean;
  stacked: boolean;
  onStack: (open: boolean) => void;
  /** Its job's drawer over the tab the user is on, in place of this one (DD-045). */
  onOpenJob: (jobId: string) => void;
  onClose: () => void;
}

export function AgencyJobInvoiceDrawer({ invoiceId, paying, stacked, onStack, onOpenJob, onClose }: Props) {
  const { invoicesQuery, invoice, clientQuery } = useAgencyJobInvoiceDrawer(invoiceId);
  // The drawer waits for its client's jobs, so it opens listing them.
  if (!invoice || !clientQuery.data) {
    const failed = invoicesQuery.isError || clientQuery.isError || (invoicesQuery.data && !invoice);
    return (
      <FinanceDrawer title={INVOICE.label} onClose={onClose}>
        <p className="text-sm text-gray-500">{failed ? `Could not load this ${INVOICE.label.toLowerCase()}.` : `Loading the ${INVOICE.label.toLowerCase()}…`}</p>
      </FinanceDrawer>
    );
  }
  const clientJobs = clientQuery.data.jobs;
  const jobsOf = (ids: string[]): LineJob[] => ids.flatMap((id) => clientJobs.filter((j) => j.id === id));
  return (
    <JobInvoiceDrawer
      key={invoice.id}
      invoice={invoice}
      clientId={invoice.client.id}
      jobs={jobsOf(invoice.jobIds)}
      billable={clientJobs.filter(toBill)}
      today={clientQuery.data.today}
      paying={paying}
      stacked={stacked}
      onStack={() => onStack(true)}
      onUnstack={() => onStack(false)}
      titlePrefix={invoice.client.name}
      onOpenJob={onOpenJob}
      onClose={onClose}
    />
  );
}
